// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Styles */
.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e0e0e0;
}

.dashboard-header h1 {
  color: #2c2c2c;
  font-size: 2.5rem;
  margin: 0;
  font-weight: 700;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-name {
  color: #424242;
  font-weight: 500;
  font-size: 1.1rem;
}

.status-badge {
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.aktyvus {
  background: #e8f5e8;
  color: #2e7d2e;
}

.status-badge.neaktyvus {
  background: #ffeaa7;
  color: #d63031;
}

/* Dashboard Tabs */
.dashboard-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #e0e0e0;
}

.tab {
  background: none;
  border: none;
  padding: 1rem 1.5rem;
  cursor: pointer;
  font-size: 1rem;
  color: #757575;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
}

.tab:hover {
  color: #2c2c2c;
  background: #f8f9fa;
}

.tab.active {
  color: #424242;
  border-bottom-color: #424242;
  font-weight: 600;
}

/* Dashboard Content */
.dashboard-content {
  min-height: 500px;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.admin-stats {
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
  transition: transform 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-card h3 {
  color: #757575;
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c2c2c;
  margin-bottom: 0.5rem;
}

.stat-limit,
.stat-subtitle {
  color: #757575;
  font-size: 0.9rem;
}

/* Progress Bar */
.progress-bar {
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 1rem;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #22c55e, #16a34a);
  border-radius: 4px;
  transition: width 0.3s ease;
}

/* Recent Activity */
.recent-activity {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
}

.recent-activity h3 {
  color: #2c2c2c;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  font-weight: 600;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.activity-item {
  display: grid;
  grid-template-columns: 150px 1fr 80px;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  align-items: center;
}

.admin-activity {
  grid-template-columns: 130px 1fr 120px 1fr;
}

.activity-time {
  color: #757575;
  font-size: 0.85rem;
  font-family: 'Courier New', monospace;
}

.activity-desc,
.activity-user,
.activity-action {
  color: #2c2c2c;
  font-weight: 500;
}

.activity-details {
  color: #757575;
  font-size: 0.9rem;
}

.activity-duration {
  color: #424242;
  font-weight: 600;
  text-align: right;
}

/* Usage Tab */
.usage-summary {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
  margin-bottom: 2rem;
}

.usage-chart {
  display: flex;
  justify-content: space-around;
  align-items: end;
  height: 200px;
  margin: 2rem 0;
}

.chart-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.bar-container {
  height: 150px;
  width: 60px;
  background: #f0f0f0;
  border-radius: 30px;
  display: flex;
  align-items: end;
  overflow: hidden;
}

.bar {
  width: 100%;
  background: linear-gradient(180deg, #424242, #616161);
  border-radius: 30px 30px 4px 4px;
  min-height: 10px;
  transition: height 0.5s ease;
}

.bar-label,
.bar-value {
  font-size: 0.85rem;
  color: #424242;
  font-weight: 500;
}

.quota-info {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
}

.warning-box {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  color: #856404;
}

/* Billing Tab */
.billing-info,
.plan-change {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
  margin-bottom: 2rem;
}

.billing-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-row:last-child {
  border-bottom: none;
}

.plan-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;
}

.plan-option {
  padding: 1.5rem;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  text-align: center;
  position: relative;
}

.plan-option.current {
  border-color: #424242;
  background: #f8f9fa;
}

.plan-price {
  font-size: 1.8rem;
  font-weight: 700;
  color: #424242;
  margin: 0.5rem 0;
}

.current-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #424242;
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
}

/* Settings Tab */
.settings-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  color: #424242;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #424242;
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

/* Buttons */
.btn-primary,
.btn-outline,
.btn-small,
.btn-danger {
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  border: none;
}

.btn-primary {
  background: #424242;
  color: white;
}

.btn-primary:hover {
  background: #616161;
}

.btn-outline {
  background: transparent;
  color: #424242;
  border: 2px solid #424242;
}

.btn-outline:hover {
  background: #424242;
  color: white;
}

.btn-small {
  padding: 0.4rem 0.8rem;
  font-size: 0.8rem;
  margin-right: 0.5rem;
  background: #f0f0f0;
  color: #424242;
}

.btn-small:hover {
  background: #e0e0e0;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover {
  background: #c82333;
}

/* Users Tab */
.users-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.users-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.search-input {
  padding: 0.6rem 1rem;
  border: 1px solid #d0d0d0;
  border-radius: 6px;
  width: 250px;
}

.users-table {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
}

.users-table table {
  width: 100%;
  border-collapse: collapse;
}

.users-table th,
.users-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.users-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.users-table tr:last-child td {
  border-bottom: none;
}

/* Analytics Tab */
.analytics-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
}

.chart-container {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
}

.chart-placeholder {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-bars {
  display: flex;
  align-items: end;
  gap: 2rem;
  height: 200px;
}

.chart-bar-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.chart-bar-group .chart-bar {
  width: 40px;
  background: linear-gradient(180deg, #424242, #616161);
  border-radius: 4px;
  min-height: 20px;
}

.chart-bar-group span {
  font-size: 0.8rem;
  color: #757575;
}

.metrics-summary {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
}

.metric-item {
  display: flex;
  justify-content: space-between;
  padding: 0.8rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.metric-item:last-child {
  border-bottom: none;
}

/* Plan Settings */
.plan-settings {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin: 1.5rem 0;
}

.plan-setting {
  padding: 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.plan-setting h4 {
  margin-bottom: 1rem;
  color: #424242;
}

.plan-setting input {
  margin-bottom: 0.5rem;
  width: 100%;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }

  .dashboard-tabs {
    flex-wrap: wrap;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .activity-item {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .admin-activity {
    grid-template-columns: 1fr;
  }

  .usage-chart {
    height: 150px;
    gap: 1rem;
  }

  .bar-container {
    height: 100px;
    width: 40px;
  }

  .plan-options {
    grid-template-columns: 1fr;
  }

  .analytics-grid {
    grid-template-columns: 1fr;
  }

  .users-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .search-input {
    width: 100%;
  }

  .users-table {
    overflow-x: auto;
  }

  .users-table table {
    min-width: 600px;
  }
}

/* Admin User Profile Styles */
.profile-header {
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
}

.profile-avatar {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #424242, #616161);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  color: white;
  font-weight: bold;
}

.profile-info h2 {
  margin: 0 0 0.5rem 0;
  color: #2c2c2c;
  font-size: 1.8rem;
}

.profile-info p {
  margin: 0 0 1rem 0;
  color: #757575;
  font-size: 1.1rem;
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.profile-section {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e0e0e0;
}

.profile-section h3 {
  margin-bottom: 2rem;
  color: #2c2c2c;
  font-size: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f0f0f0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-item label {
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-item span {
  color: #2c2c2c;
  font-size: 1rem;
  padding: 0.8rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.ai-prompts {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.prompt-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  background: #f8f9fa;
}

.prompt-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  background: white;
  border-bottom: 1px solid #e0e0e0;
}

.prompt-header h4 {
  margin: 0;
  color: #2c2c2c;
}

.prompt-language, .prompt-version {
  font-size: 0.8rem;
  background: #e0e0e0;
  padding: 0.3rem 0.8rem;
  border-radius: 12px;
  color: #424242;
}

.prompt-content {
  padding: 1.5rem;
  background: #fafafa;
  max-height: 300px;
  overflow-y: auto;
}

.prompt-content pre {
  margin: 0;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  color: #2c2c2c;
  line-height: 1.5;
}

.prompt-footer {
  padding: 1rem 1.5rem;
  background: white;
  border-top: 1px solid #e0e0e0;
  color: #757575;
}

.activity-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 1rem;
  border: 1px solid #e0e0e0;
}

.activity-time {
  font-size: 0.9rem;
  color: #757575;
  font-weight: 500;
  white-space: nowrap;
}

.activity-action {
  font-weight: 600;
  color: #424242;
}

.activity-details {
  color: #757575;
  font-size: 0.9rem;
}

.placeholder-content {
  padding: 1rem 0;
}

.status-badge.laukiantis {
  background: #fff3cd;
  color: #856404;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  border: none;
  text-decoration: none;
}

.btn-secondary:hover {
  background: #5a6268;
}

@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }

  .user-actions {
    flex-direction: column;
    width: 100%;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .activity-item {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .prompt-header {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}

/* Usage and Payments Tabs */
.stat-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.stat-card h4 {
  margin: 0 0 1rem 0;
  color: #757575;
  font-size: 0.9rem;
  font-weight: 500;
}

.stat-value {
  font-size: 2rem;
  font-weight: bold;
  color: #2c2c2c;
  margin: 0;
}

/* White text for stat-cards and stat-values on blue background */
.stat-card h4,
.stat-card .stat-value {
  color: white;
}

.call-types {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.call-type-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.recent-calls {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.call-item {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 1rem;
  padding: 0.8rem 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  align-items: center;
}

.call-time {
  font-size: 0.85rem;
  color: #757575;
  white-space: nowrap;
}

.call-type {
  color: #424242;
  font-weight: 500;
}

.call-duration {
  font-size: 0.85rem;
  color: #757575;
  white-space: nowrap;
}

.payments-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.status-badge.paid {
  background: #e8f5e8;
  color: #2e7d2e;
}

@media (max-width: 768px) {
  .call-item {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }

  .call-type-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .payments-table {
    overflow-x: auto;
  }

  .payments-table table {
    min-width: 600px;
  }
}

/* Form Input Styles */
.form-input {
  padding: 0.5rem 0.75rem;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 0.9rem;
  font-family: inherit;
  width: 100%;
  max-width: 300px;
  transition: border-color 0.2s ease;
}

.form-input:focus {
  outline: none;
  border-color: #424242;
  box-shadow: 0 0 0 2px rgba(66, 66, 66, 0.1);
}

.form-input:hover {
  border-color: #a0a0a0;
}

.info-item input.form-input,
.info-item select.form-input {
  margin: 0;
}

/* Make sure info items with inputs have proper spacing */
.info-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-item label {
  font-weight: 600;
  color: #424242;
}

.info-item span,
.info-item input,
.info-item select {
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;;;;EAIE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,wDAAwD;EACxD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,iEAAiE;AACjE;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;AACX;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb","sourcesContent":["/* Dashboard Styles */\n.dashboard-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.dashboard-header h1 {\n  color: #2c2c2c;\n  font-size: 2.5rem;\n  margin: 0;\n  font-weight: 700;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-name {\n  color: #424242;\n  font-weight: 500;\n  font-size: 1.1rem;\n}\n\n.status-badge {\n  padding: 0.4rem 1rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.aktyvus {\n  background: #e8f5e8;\n  color: #2e7d2e;\n}\n\n.status-badge.neaktyvus {\n  background: #ffeaa7;\n  color: #d63031;\n}\n\n/* Dashboard Tabs */\n.dashboard-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.tab {\n  background: none;\n  border: none;\n  padding: 1rem 1.5rem;\n  cursor: pointer;\n  font-size: 1rem;\n  color: #757575;\n  border-bottom: 3px solid transparent;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.tab:hover {\n  color: #2c2c2c;\n  background: #f8f9fa;\n}\n\n.tab.active {\n  color: #424242;\n  border-bottom-color: #424242;\n  font-weight: 600;\n}\n\n/* Dashboard Content */\n.dashboard-content {\n  min-height: 500px;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.admin-stats {\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n}\n\n.stat-card {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n  transition: transform 0.2s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n}\n\n.stat-card h3 {\n  color: #757575;\n  font-size: 0.9rem;\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2c2c2c;\n  margin-bottom: 0.5rem;\n}\n\n.stat-limit,\n.stat-subtitle {\n  color: #757575;\n  font-size: 0.9rem;\n}\n\n/* Progress Bar */\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: #f0f0f0;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-top: 1rem;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #22c55e, #16a34a);\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n/* Recent Activity */\n.recent-activity {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n}\n\n.recent-activity h3 {\n  color: #2c2c2c;\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.activity-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.activity-item {\n  display: grid;\n  grid-template-columns: 150px 1fr 80px;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  align-items: center;\n}\n\n.admin-activity {\n  grid-template-columns: 130px 1fr 120px 1fr;\n}\n\n.activity-time {\n  color: #757575;\n  font-size: 0.85rem;\n  font-family: 'Courier New', monospace;\n}\n\n.activity-desc,\n.activity-user,\n.activity-action {\n  color: #2c2c2c;\n  font-weight: 500;\n}\n\n.activity-details {\n  color: #757575;\n  font-size: 0.9rem;\n}\n\n.activity-duration {\n  color: #424242;\n  font-weight: 600;\n  text-align: right;\n}\n\n/* Usage Tab */\n.usage-summary {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n  margin-bottom: 2rem;\n}\n\n.usage-chart {\n  display: flex;\n  justify-content: space-around;\n  align-items: end;\n  height: 200px;\n  margin: 2rem 0;\n}\n\n.chart-bar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.bar-container {\n  height: 150px;\n  width: 60px;\n  background: #f0f0f0;\n  border-radius: 30px;\n  display: flex;\n  align-items: end;\n  overflow: hidden;\n}\n\n.bar {\n  width: 100%;\n  background: linear-gradient(180deg, #424242, #616161);\n  border-radius: 30px 30px 4px 4px;\n  min-height: 10px;\n  transition: height 0.5s ease;\n}\n\n.bar-label,\n.bar-value {\n  font-size: 0.85rem;\n  color: #424242;\n  font-weight: 500;\n}\n\n.quota-info {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n}\n\n.warning-box {\n  background: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-top: 1rem;\n  color: #856404;\n}\n\n/* Billing Tab */\n.billing-info,\n.plan-change {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n  margin-bottom: 2rem;\n}\n\n.billing-details {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.8rem 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.detail-row:last-child {\n  border-bottom: none;\n}\n\n.plan-options {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1.5rem;\n}\n\n.plan-option {\n  padding: 1.5rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  text-align: center;\n  position: relative;\n}\n\n.plan-option.current {\n  border-color: #424242;\n  background: #f8f9fa;\n}\n\n.plan-price {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #424242;\n  margin: 0.5rem 0;\n}\n\n.current-badge {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background: #424242;\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n/* Settings Tab */\n.settings-section {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n  margin-bottom: 2rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  color: #424242;\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 0.8rem;\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #424242;\n}\n\n.form-group textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n/* Buttons */\n.btn-primary,\n.btn-outline,\n.btn-small,\n.btn-danger {\n  padding: 0.8rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  border: none;\n}\n\n.btn-primary {\n  background: #424242;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #616161;\n}\n\n.btn-outline {\n  background: transparent;\n  color: #424242;\n  border: 2px solid #424242;\n}\n\n.btn-outline:hover {\n  background: #424242;\n  color: white;\n}\n\n.btn-small {\n  padding: 0.4rem 0.8rem;\n  font-size: 0.8rem;\n  margin-right: 0.5rem;\n  background: #f0f0f0;\n  color: #424242;\n}\n\n.btn-small:hover {\n  background: #e0e0e0;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #c82333;\n}\n\n/* Users Tab */\n.users-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.users-actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.search-input {\n  padding: 0.6rem 1rem;\n  border: 1px solid #d0d0d0;\n  border-radius: 6px;\n  width: 250px;\n}\n\n.users-table {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n}\n\n.users-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.users-table th,\n.users-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.users-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #424242;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.users-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Analytics Tab */\n.analytics-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 2rem;\n}\n\n.chart-container {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n}\n\n.chart-placeholder {\n  height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chart-bars {\n  display: flex;\n  align-items: end;\n  gap: 2rem;\n  height: 200px;\n}\n\n.chart-bar-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.chart-bar-group .chart-bar {\n  width: 40px;\n  background: linear-gradient(180deg, #424242, #616161);\n  border-radius: 4px;\n  min-height: 20px;\n}\n\n.chart-bar-group span {\n  font-size: 0.8rem;\n  color: #757575;\n}\n\n.metrics-summary {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n}\n\n.metric-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.8rem 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.metric-item:last-child {\n  border-bottom: none;\n}\n\n/* Plan Settings */\n.plan-settings {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin: 1.5rem 0;\n}\n\n.plan-setting {\n  padding: 1rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n}\n\n.plan-setting h4 {\n  margin-bottom: 1rem;\n  color: #424242;\n}\n\n.plan-setting input {\n  margin-bottom: 0.5rem;\n  width: 100%;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-header {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  }\n\n  .dashboard-tabs {\n    flex-wrap: wrap;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .activity-item {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .admin-activity {\n    grid-template-columns: 1fr;\n  }\n\n  .usage-chart {\n    height: 150px;\n    gap: 1rem;\n  }\n\n  .bar-container {\n    height: 100px;\n    width: 40px;\n  }\n\n  .plan-options {\n    grid-template-columns: 1fr;\n  }\n\n  .analytics-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .users-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .search-input {\n    width: 100%;\n  }\n\n  .users-table {\n    overflow-x: auto;\n  }\n\n  .users-table table {\n    min-width: 600px;\n  }\n}\n\n/* Admin User Profile Styles */\n.profile-header {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  margin-bottom: 2rem;\n  padding: 2rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n}\n\n.profile-avatar {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #424242, #616161);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  color: white;\n  font-weight: bold;\n}\n\n.profile-info h2 {\n  margin: 0 0 0.5rem 0;\n  color: #2c2c2c;\n  font-size: 1.8rem;\n}\n\n.profile-info p {\n  margin: 0 0 1rem 0;\n  color: #757575;\n  font-size: 1.1rem;\n}\n\n.user-actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.profile-section {\n  background: white;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.08);\n  border: 1px solid #e0e0e0;\n}\n\n.profile-section h3 {\n  margin-bottom: 2rem;\n  color: #2c2c2c;\n  font-size: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.info-item label {\n  font-weight: 600;\n  color: #424242;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-item span {\n  color: #2c2c2c;\n  font-size: 1rem;\n  padding: 0.8rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n}\n\n.ai-prompts {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.prompt-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f8f9fa;\n}\n\n.prompt-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  background: white;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.prompt-header h4 {\n  margin: 0;\n  color: #2c2c2c;\n}\n\n.prompt-language, .prompt-version {\n  font-size: 0.8rem;\n  background: #e0e0e0;\n  padding: 0.3rem 0.8rem;\n  border-radius: 12px;\n  color: #424242;\n}\n\n.prompt-content {\n  padding: 1.5rem;\n  background: #fafafa;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.prompt-content pre {\n  margin: 0;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  color: #2c2c2c;\n  line-height: 1.5;\n}\n\n.prompt-footer {\n  padding: 1rem 1.5rem;\n  background: white;\n  border-top: 1px solid #e0e0e0;\n  color: #757575;\n}\n\n.activity-item {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  border: 1px solid #e0e0e0;\n}\n\n.activity-time {\n  font-size: 0.9rem;\n  color: #757575;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.activity-action {\n  font-weight: 600;\n  color: #424242;\n}\n\n.activity-details {\n  color: #757575;\n  font-size: 0.9rem;\n}\n\n.placeholder-content {\n  padding: 1rem 0;\n}\n\n.status-badge.laukiantis {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: white;\n  padding: 0.8rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  border: none;\n  text-decoration: none;\n}\n\n.btn-secondary:hover {\n  background: #5a6268;\n}\n\n@media (max-width: 768px) {\n  .profile-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 1.5rem;\n  }\n\n  .user-actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .activity-item {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .prompt-header {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n}\n\n/* Usage and Payments Tabs */\n.stat-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 1.5rem;\n  text-align: center;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.05);\n}\n\n.stat-card h4 {\n  margin: 0 0 1rem 0;\n  color: #757575;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #2c2c2c;\n  margin: 0;\n}\n\n/* White text for stat-cards and stat-values on blue background */\n.stat-card h4,\n.stat-card .stat-value {\n  color: white;\n}\n\n.call-types {\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n}\n\n.call-type-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.8rem 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n}\n\n.recent-calls {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.call-item {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 1rem;\n  padding: 0.8rem 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n  align-items: center;\n}\n\n.call-time {\n  font-size: 0.85rem;\n  color: #757575;\n  white-space: nowrap;\n}\n\n.call-type {\n  color: #424242;\n  font-weight: 500;\n}\n\n.call-duration {\n  font-size: 0.85rem;\n  color: #757575;\n  white-space: nowrap;\n}\n\n.payments-table {\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e0e0e0;\n}\n\n.status-badge.paid {\n  background: #e8f5e8;\n  color: #2e7d2e;\n}\n\n@media (max-width: 768px) {\n  .call-item {\n    grid-template-columns: 1fr;\n    gap: 0.5rem;\n  }\n\n  .call-type-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .payments-table {\n    overflow-x: auto;\n  }\n\n  .payments-table table {\n    min-width: 600px;\n  }\n}\n\n/* Form Input Styles */\n.form-input {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #d0d0d0;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  width: 100%;\n  max-width: 300px;\n  transition: border-color 0.2s ease;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #424242;\n  box-shadow: 0 0 0 2px rgba(66, 66, 66, 0.1);\n}\n\n.form-input:hover {\n  border-color: #a0a0a0;\n}\n\n.info-item input.form-input,\n.info-item select.form-input {\n  margin: 0;\n}\n\n/* Make sure info items with inputs have proper spacing */\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.info-item label {\n  font-weight: 600;\n  color: #424242;\n}\n\n.info-item span,\n.info-item input,\n.info-item select {\n  color: #666;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
